import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export interface DatenverwaltungPartnerState {
    names: any;
}

export class DatenverwaltungPartner extends React.Component<{}, DatenverwaltungPartnerState> {

    constructor(props: any) {
        super(props);
        this.state = {
            names: null
        };
        this.customFormatter = this.customFormatter.bind(this);
        this.onDataLoaded = this.onDataLoaded.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    customFormatter(field: string, value: any, data: any, row: any): any {
        return field === 'name' && ((this.state.names || {})[value] || []).length > 1
            ? `${value} (${this.state.names[value].indexOf(data.tid) + 1})`
            : value;
    }

    onDataLoaded(data: any[]): void {
        const names: any = {};
        (data || [])
            .sort((a: any, b: any) => a.tid - b.tid)
            .forEach((item: any) => {
                if (typeof names[item.name] === 'undefined') {
                    names[item.name] = [];
                }
                names[item.name].push(item.tid);
            });
        this.setState({ names });
    }

    render(): JSX.Element {
        return (
            <WFormsTableWrapper
                entity={IDs.ENT_PARTNER}
                module={IDs.MOD_ETOOL_ADMIN}
                actions={['add', 'edit', 'delete']}
                customClass='Custom-ETA'
                formLayout='flowV2'
                customFormatter={this.customFormatter}
                onDataLoaded={this.onDataLoaded}
                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_PARTNER)}
                showColumnsHelp
            />
        );
    }
}
